import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-datetime-model',
  templateUrl: './datetime-model.component.html',
  styleUrls: ['./datetime-model.component.scss'],
})
export class DatetimeModelComponent implements OnInit {
  @Input() value: Date;
  constructor(private modelController: ModalController) {}

  filter(event) {
    this.modelController.dismiss(event.detail.value);
  }
  ionViewDidEnter() {
    // this.value = this.value ? this.value : new Date();
  }
  ngOnInit() {}
}
